import Consultation from './consultation'

export default [
  {
    path: '/consultation',
    name: 'consultation',
    component: Consultation
  }
]



// WEBPACK FOOTER //
// ./src/components/consultation/consultation-router.js